import {
  isRouteErrorResponse,
  Links,
  Meta,
  Outlet,
  Scripts,
  ScrollRestoration,
} from "react-router";

import type { Route } from "./+types/root";
import "./app.css";

import { AuthProvider } from './context/AuthContext';
import { DEV_MODE } from './config/settings';

export const links: Route.LinksFunction = () => [
  { rel: "preconnect", href: "https://fonts.googleapis.com" },
  {
    rel: "preconnect",
    href: "https://fonts.gstatic.com",
    crossOrigin: "anonymous",
  },
  {
    rel: "stylesheet",
    href: "https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap",
  },
  {
    rel: "icon",
    href: "/bus.ico",
    type: "image/x-icon",
  },
];

export function Layout({ children }: { children: React.ReactNode }) {
  return (
    <html lang="en">
      <head>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <Meta />
        <Links />
      </head>
      <body style={{
        backgroundImage: 'url(/school-pattern-background.svg)',
        backgroundRepeat: 'repeat',
        backgroundSize: '941px 941px'
      }}>
        <AuthProvider>
            {children}
            {DEV_MODE && (
              <div className="fixed bottom-0 left-0 right-0 z-[9999] bg-orange-500 text-white text-center py-2 px-4 font-bold text-sm shadow-lg">
                🚧 DEVELOPMENT ENVIRONMENT 🚧
              </div>
            )}
          </AuthProvider>
        <ScrollRestoration />
        <Scripts />
      </body>
    </html>
  );
}

export default function App() {
  return <Outlet />;
}

export function ErrorBoundary({ error }: Route.ErrorBoundaryProps) {
  let title = 'Something went wrong';
  let message = 'An unexpected error occurred. Please try again.';

  if (isRouteErrorResponse(error)) {
    title = `${error.status} ${error.statusText || ''}`.trim();
    message = error.data?.toString() || 'The page you requested could not be found.';
  } else if (error instanceof Error) {
    message = DEV_MODE ? error.message : 'An unexpected error occurred. Please try again.';
  }

  return (
    <div className="flex min-h-screen items-center justify-center p-4">
      <div className="text-center bg-white p-8 rounded-lg shadow-lg max-w-md">
        <h1 className="text-2xl font-bold text-[#001489] mb-2">{title}</h1>
        <p className="text-gray-600 mb-6">{message}</p>
        <a
          href="/"
          className="inline-block bg-[#001489] text-white px-6 py-2 rounded hover:bg-blue-900 transition-colors"
        >
          Go Home
        </a>
      </div>
    </div>
  );
}
